import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { LinkButton } from '~/features/navigation'
import { HighlightV3Mutators } from '~/mutators/highlights-v3'
import { useTRPC } from '~/services/trpc'

import { DEFAULT_VALUES, HighlightForm } from './-components/form'
import { HighlightPaneShell } from './-components/highlight-pane'

export const Route = createFileRoute(
  '/_authenticated/$alias/_app/highlights/$highlightCategoryId/new',
)({
  component: RouteComponent,
  loader: async ({ context: { trpc, queryClient }, params }) => {
    await queryClient.ensureQueryData(
      trpc.highlightCategoriesV3.getById.queryOptions(params.highlightCategoryId),
    )
    return
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const params = Route.useParams()
  const trpc = useTRPC()
  const { data: category } = useQuery(
    trpc.highlightCategoriesV3.getById.queryOptions(params.highlightCategoryId),
  )

  const { create } = HighlightV3Mutators.useCreate({
    onSuccess: () => {
      void navigate({
        to: '/$alias/highlights',
        params,
      })
    },
  })

  return (
    <HighlightPaneShell
      alias={params.alias}
      title="New highlight"
      description={
        category
          ? `Create a new highlight in ${category.name}.`
          : 'Create a new highlight.'
      }
    >
        <HighlightForm
          defaultValues={DEFAULT_VALUES}
          submitLabel="Create highlight"
          cancelAction={
            <LinkButton
              to="/$alias/highlights"
              from={Route.fullPath}
              params={{ alias: params.alias }}
              variant="secondary"
            >
              Cancel
            </LinkButton>
          }
          onSubmit={async (values) => {
            await create({
              ...values,
              categoryId: params.highlightCategoryId,
            })
          }}
        />
    </HighlightPaneShell>
  )
}
